import React, { useCallback, useMemo, useState, useRef, useEffect } from 'react'

import { useSelector, useDispatch } from 'react-redux';

import { Report, UnidataTable, Modal } from '~/components';
import {
    RadioGroup, Select
} from '~/components/Form';

import { format, subDays, setHours, setMinutes, setSeconds, parseISO, parse } from 'date-fns';
import { SelectComplete } from '~/componentslocal';
import * as Yup from 'yup';
import { number, t, parseDateString } from '~/helpers';
import { TypeFilters } from '~/components';
import * as S from './styles'
import { toast } from 'react-toastify';

import qs from 'querystring';
import api from '~/services/api';
import { isEmpty } from 'lodash';
import { recordFiltering } from '~/store/modules/manutExcluirVazamento/actions';
import ModalExclude from './ModalExclude'



export default function ExcluirVazamento() {


    const [open, setOpen] = useState(true);
    const [grid, setGrid] = useState(false);
    const [query, setQuery] = useState({});
    const [rowQuery, setRowQuery] = useState({
        data_atual: '',
        posto: '',
        tarefa: '',
        period: '',
        status: ''

    })
    const reference = useRef(null);

    const filterRef = useRef(null);
    const modalRef = useRef(null);

    const [post, setPost] = useState('')
    const [dataObjto, setDataObjto] = useState({});

    const dataRedux = useSelector((state) => state.manutExcluirVazamento);
    const titlePage = useMemo(() => 'CANCELA VAZAMENTO', []);

    const [tipoTypeFilters, setTipoTypeFilters] = useState(0)
    const [dataHoraInicial, setDataHoraInicial] = useState('')
    const [dataHoraFinal, setDataHoraFinal] = useState('')




    const handleGetData = useCallback((value) => {
        setTipoTypeFilters(value.tipo)
        if (value.tipo === 1) {
            setDataHoraInicial(value.datahora_inicio)
            setDataHoraFinal(value.datahora_fim)
        } else if (value.tipo == 5) {

            setDataHoraInicial(value.turno_inicio ? value.turno_inicio.turn_datahora_ini : value.data_inicio_turno + ' 00:00:00')
            setDataHoraFinal(value.turno_fim ? value.turno_fim.turn_datahora_fim : value.data_fim_turno + ' 23:59:59')

        } else if (value.tipo == 2) {
            setDataHoraInicial(value.data_inicio + ' 00:00:00')
            setDataHoraFinal(value.data_fim + ' 23:59:59')
        }
        setDataObjto(value);
    }, [filterRef]);

    const schemaDataHora = Yup.object().shape({
        datahora_inicio: Yup.date()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio')),
        datahora_fim: Yup.date()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio'))
    });

    const schemaOnlyDataTurno = Yup.object().shape({
        data_inicio_turno: Yup.date()
            .typeError('Data inválida')
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio')),
        data_fim_turno: Yup.date()
            .typeError('Data inválida')
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio')),
        posto: Yup.string().typeError(t('s.geral.validacao.campoobrigatorio')).required(t('s.geral.validacao.campoobrigatorio'))
    });

    const handleValidate = useCallback(async (data) => {
        try {

            if (tipoTypeFilters == 1) {
                await schemaDataHora.validate({ datahora_inicio: dataHoraInicial, datahora_fim: dataHoraFinal }, {
                    abortEarly: false,
                });
            } else if (tipoTypeFilters == 5) {
                await schemaOnlyDataTurno.validate({ data_inicio_turno: dataHoraInicial, data_fim_turno: dataHoraFinal, posto: post.post_cod_posto }, {
                    abortEarly: false,
                });
            }
            filterRef.current.setErrors({})

        } catch (err) {
            console.log(err)
            const form = {};

            if (err instanceof Yup.ValidationError) {
                err.inner.forEach((error) => {
                    form[error.path] = error.message.replace(`${error.path} `, '');
                });
                filterRef.current.setErrors(form);

            }
            throw err;
        }
    }, [dataObjto, dataHoraInicial, dataHoraFinal, filterRef, tipoTypeFilters, post])

    const headerUnidataTable = useMemo(
        () => [
            {
                id: 'post_desc',
                label: 'Posto',
            },
            {
                id: 'abas_datahora_ini',
                label: 'Data',
                formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm:ss'),
            },
            {
                id: 'bico_cod_bico',
                label: 'Bico',
            },
            {
                id: 'abas_vol_amb',
                label: 'Volume Amb.',
            },
            {
                id: 'abas_encer_ini',
                label: 'Enc. Inicial',
            },
            {
                id: 'abas_encer_fim',
                label: 'Enc. Fim',
            },

        ],
        []
    );

    const handleShowGrid = useCallback((data) => {
        const { post_cod_posto,
            turn_datahora_ini,
            turn_datahora_fim, } = data


        const dataQuery = {
            wherefield: ['datahorainicial', 'datahorafinal',],
            valuewherefield: [
                turn_datahora_ini,
                turn_datahora_fim,
            ],
            typewherefield: ['MAIOR_IGUAL', 'MENOR_IGUAL',],
        }




        if (!isEmpty(post_cod_posto)) {
            dataQuery.wherefield.push('post_cod_posto')
            dataQuery.valuewherefield.push(post_cod_posto)
            dataQuery.typewherefield.push('EQUALS')
        }


        setRowQuery({
            data_atual: format(new Date(), 'dd/MM/yyyy'),
            posto: !isEmpty(post_cod_posto) ? data.posto_str : 'Todos',
            period: `${turn_datahora_ini} à ${turn_datahora_fim}`,

        })

        setOpen(false)
        setGrid(true)
        setQuery(dataQuery)

    }, [])


    const handleSerializeForm = useCallback((param) => {

        const serializeObject = {
            ...param,
            post_cod_posto: post.post_cod_posto ? post.post_cod_posto : '',
            posto_str: post.post_desc ? post.post_desc : '',
            turn_datahora_ini: dataHoraInicial,
            turn_datahora_fim: dataHoraFinal,
        }

        handleShowGrid(serializeObject)

        return undefined



    }, [dataHoraInicial, dataHoraFinal, post])

    const openModalWithRecordDetails = useCallback((data) => {
        if (!isEmpty(data)) {
            handleValidateVazamento(data)
        }

    }, [dataHoraFinal, dataHoraInicial]);

    const handleValidateVazamento = useCallback(async (dataVazamento) => {
        const params = {
            chave: `(POST_COD_POSTO = &#183${dataVazamento.post_cod_posto}&#183  AND ABAS_COD_ABAS = ${dataVazamento.abas_cod_abas})`,
            status: 'P',
            codigoposto: dataVazamento.post_cod_posto,
            codtarefa: 0
        }

        const response = await api.get('manutencaocontrole/getmanutencaoagendaexiste',
            {
                params: { ...params },
                paramsSerializer: (param) => qs.stringify(param),
            })

        if (!isEmpty(response.data)) {
            toast.error('Já existe uma tarefa agendada em aberto !!')
        } else {
            modalRef.current.handleOpenModal({ data: { ...dataVazamento, filter_datahora_ini: dataHoraInicial, filter_datahora_fim: dataHoraFinal } });
        }

    }, [dataHoraFinal, dataHoraInicial, modalRef])


    if (grid && !isEmpty(query))
        return (
            <>
                <S.HeaderWrapper>
                    <li>
                        <span>Data Emissão:</span>
                        {rowQuery.data_atual}
                    </li>
                    <li>
                        <span>Período:</span> {rowQuery.period}
                    </li>
                    <li>
                        <span>Posto:</span>
                        {rowQuery.posto}
                    </li>
                </S.HeaderWrapper>
                <UnidataTable
                    fixed
                    header={headerUnidataTable}
                    read={recordFiltering}
                    redux={dataRedux}
                    title={titlePage}
                    query={query}
                    onRow={(value) => openModalWithRecordDetails(value)}
                    keys={['post_desc']}
                    detach="post_desc"
                    maxHeight="calc(100vh - 36rem)"
                    create={false}
                    update={false}
                    delete={false}
                />

                <Modal
                    disableBackdropClick
                    disableEscapeKeyDown
                    form
                    maxWidth="sm"
                    ref={modalRef}
                    title="Cancela Vazamento"
                    component={ModalExclude}
                    labelConfirm="Salvar"
                    labelCancell="Fechar"
                />

            </>
        );


    return (
        <>
            <Report
                ref={reference}
                open={open}
                onClose={() => setOpen(false)}
                title="CANCELA VAZAMENTO"
                validate={handleValidate}
                serialize={(param) => handleSerializeForm(param)}
            >

                <SelectComplete
                    name="posto"
                    title="Posto"
                    label="post_desc"
                    unique="post_cod_posto"
                    url="usuarioposto"
                    getValue={(value) => {
                        setPost(value);
                    }}
                />

                <TypeFilters
                    ref={filterRef}
                    initials={{
                        tipo: 1,
                        datahora_inicio: format(setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0), 'dd/MM/yyyy HH:mm:ss'),
                        datahora_fim: format(setSeconds(setMinutes(setHours(new Date(), 23), 59), 59), 'dd/MM/yyyy HH:mm:ss')
                    }}
                    name="filtroData"
                    numberOfYears={9}
                    options={[
                        { label: t('s.geral.filtro.periododatahora'), value: 1 },
                        { label: t('s.geral.filtro.turno'), value: 5 },
                    ]}
                    onCallback={handleGetData}
                    initialURL="/turno/getturnosinicio"
                    finalURL="/turno/getturnosfim"
                    code={post.post_cod_posto}
                />


                <RadioGroup
                    name="tipo"
                    label="Formato"
                    options={[
                        { label: 'Tela', value: 'tela' }]
                    }
                    defaultValue="tela"
                    serialize={(value) => value}
                    row
                />

            </Report>
        </>

    )
}
